"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPatcher = void 0;
var hot_patcher_1 = __importDefault(require("hot-patcher"));
var __patcher = null;
function getPatcher() {
    if (!__patcher) {
        __patcher = new hot_patcher_1.default();
    }
    return __patcher;
}
exports.getPatcher = getPatcher;
